import React, { useState, useEffect } from 'react';
import { Card, CardBody, Typography, Input, Button } from "@material-tailwind/react";
import axios from 'axios';
import { FaTrash, FaPlus, FaCheck, FaTimes, FaPenAlt } from 'react-icons/fa';
import { useAuth } from '../AuthContext';
const { rootUrl } = require('../../../config/config');

const InsuranceCompany = () => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [, setError] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState('');
  const [newName, setNewName] = useState('');
  const { user } = useAuth();

  // Fetch all insurance companies
  const fetchCompanies = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${rootUrl}/insurance/companies`);
      setCompanies(response.data);
      setError('');
    } catch (err) {
      setError('Failed to fetch insurance companies.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  // Start editing a row
  const startEdit = (company) => {
    setEditingId(company.id);
    setEditName(company.name);
  };

  // Cancel editing
  const cancelEdit = () => {
    setEditingId(null);
    setEditName('');
  };

  // Save an edited row
  const saveEdit = async (id) => {
    try {
      await axios.put(`${rootUrl}/insurance/companies/${id}`, { name: editName.toUpperCase() });
      cancelEdit();
      fetchCompanies();
    } catch (err) {
      setError('Failed to update insurance company.');
    }
  };

  // Delete a company
  const deleteCompany = async (id) => {
    if (!window.confirm('Are you sure you want to delete this insurance company?')) return;
    try {
      await axios.delete(`${rootUrl}/insurance/companies/${id}`);
      fetchCompanies();
    } catch (err) {
      setError('Failed to delete insurance company.');
    }
  };

  // Add a new company
  const addCompany = async (e) => {
    console.log(user)
    e.preventDefault();
    if (!newName.trim()) return;
    try {
      await axios.post(`${rootUrl}/insurance/companies`, { name: newName.toUpperCase(), input_by: user.username });
      setNewName('');
      fetchCompanies();
    } catch (err) {
      setError('Failed to add insurance company.');
    }
  };

  return (
    <>
      <Card className="w-full max-w-4xl mt-6 border-t">
        <CardBody>
          <h2 className="text-2xl font-semibold text-gray-800 mb-6">
            Insurance Companies
          </h2>
          <form onSubmit={addCompany} className="flex mb-6">
            <Input
              type="text"
              label="New Company Name"
              value={newName}
              onChange={(e) => setNewName(e.target.value.toUpperCase())}
              className="flex-grow uppercase"
              style={{ textTransform: 'uppercase' }}
            />
            <Button
              type="submit"
              variant="gradient"
              color="blue"
              className="ml-4 flex items-center"
            >
              <FaPlus className="mr-2" /> Add
            </Button>
          </form>

          {loading ? (
            <Typography>Loading...</Typography>
          ) : (
            <table className="w-full table-auto border-collapse">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border px-4 py-2 text-left">ID</th>
                  <th className="border px-4 py-2 text-left">Name</th>
                  <th className="border px-4 py-2 text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {companies.map((company) => (
                  <tr key={company.id} className="hover:bg-gray-50">
                    <td className="border px-4 py-2">{company.id}</td>
                    <td className="border px-4 py-2">
                      {editingId === company.id ? (
                        <Input
                          type="text"
                          value={editName}
                          onChange={(e) => setEditName(e.target.value.toUpperCase())}
                          size="sm"
                          className="uppercase"
                          style={{ textTransform: 'uppercase' }}
                        />
                      ) : (
                        <Typography className="uppercase">{company.name}</Typography>
                      )}
                    </td>
                    <td className="border px-4 py-2 text-center space-y-2 sm:space-y-0 sm:space-x-2">
                      {editingId === company.id ? (
                        <>
                          <Button
                            
                            onClick={() => saveEdit(company.id)}
                            className="bg-transparent rounded-none shadow-none outline-red-100"
                          >
                            <FaCheck className="text-green-700" />
                          </Button>
                          <Button
                            onClick={cancelEdit}
                            className="bg-transparent rounded-none shadow-none"
                          >
                            <FaTimes className="text-orange-700" />
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            onClick={() => startEdit(company)}
                            className="bg-transparent shadow-none"
                          >
                            <FaPenAlt className="text-blue-gray-700" />
                          </Button>
                          <Button
                            onClick={() => deleteCompany(company.id)}
                            className="bg-transparent shadow-none"
                          >
                            <FaTrash className="text-red-700" />
                          </Button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </CardBody>
      </Card>
    </>
  );
};

export default InsuranceCompany;
